import { Constants } from '../util/Constants';
import { Util } from '../util/Util';

export class UserProfile {
  public id: number;
  public nickname: string = "";
  public rank: number = 0;
  public score: number = 0;
  public profitability: number = 0;
  public accuracy: number = 0;
  public win: number = 0;
  public lose: number = 0;
  public subscribeType: number = 0;
  public accuracyRanking: number = 0;
  public profitabilityRanking: number = 0;
  public last7DaysAccuracyRanking: number = 0;
  public last7DaysProfitabilityRanking: number = 0;
  public profit: number = 0;
  public last7DaysProfit: number = 0;
  public profitRanking: number = 0;
  public last7DaysProfitRanking: number = 0;
  public last7DaysProfitability: number = 0;
  public last7DaysAccuracy: number = 0;
  public highestScore: number = -1;
  public allowVoucherBuyPackage: boolean = false;
  public allowTipsPackageRefund: boolean = false;


  constructor(id: number, nickname: string, rank: number, score: number, profitability: number,
      accuracy: number, win: number, lose: number, subscribeType: number, accuracyRanking: number,
      profitabilityRanking: number, last7DaysAccuracyRanking: number,
      last7DaysProfitabilityRanking: number, profit: number, last7DaysProfit: number,
      profitRanking: number, last7DaysProfitRanking: number,
      last7DaysProfitability: number, last7DaysAccuracy: number, highestScore: number,
      allowVoucherBuyPackage: boolean, allowTipsPackageRefund: boolean) {
    this.id = id;
    this.nickname = nickname;
    this.rank = rank;
    this.score = score;
    this.profitability = profitability;
    this.accuracy = accuracy;
    this.win = win;
    this.lose = lose;
    this.subscribeType = subscribeType;
    this.accuracyRanking = accuracyRanking;
    this.profitabilityRanking = profitabilityRanking;
    this.last7DaysAccuracyRanking = last7DaysAccuracyRanking;
    this.last7DaysProfitabilityRanking = last7DaysProfitabilityRanking;
    this.profit = profit;
    this.last7DaysProfit = last7DaysProfit;
    this.profitRanking = profitRanking;
    this.last7DaysProfitRanking = last7DaysProfitRanking;
    this.last7DaysProfitability = last7DaysProfitability;
    this.last7DaysAccuracy = last7DaysAccuracy;
    this.highestScore = highestScore;
    this.allowVoucherBuyPackage = allowVoucherBuyPackage;
    this.allowTipsPackageRefund = allowTipsPackageRefund;
  }

  copy(userProfile: UserProfile) {
    this.id = userProfile.id;
    this.nickname = userProfile.nickname;
    this.rank = userProfile.rank;
    this.score = userProfile.score;
    this.profitability = userProfile.profitability;
    this.accuracy = userProfile.accuracy;
    this.win = userProfile.win;
    this.lose = userProfile.lose;
    this.subscribeType = userProfile.subscribeType;
    this.accuracyRanking = userProfile.accuracyRanking;
    this.profitabilityRanking = userProfile.profitabilityRanking;
    this.last7DaysAccuracyRanking = userProfile.last7DaysAccuracyRanking;
    this.last7DaysProfitabilityRanking = userProfile.last7DaysProfitabilityRanking;
    this.profit = userProfile.profit;
    this.last7DaysProfit = userProfile.last7DaysProfit;
    this.profitRanking = userProfile.profitRanking;
    this.last7DaysProfitRanking = userProfile.last7DaysProfitRanking;
    this.last7DaysProfitability = userProfile.last7DaysProfitability;
    this.last7DaysAccuracy = userProfile.last7DaysAccuracy;
    this.highestScore = userProfile.highestScore;
    this.allowVoucherBuyPackage = userProfile.allowVoucherBuyPackage;
    this.allowTipsPackageRefund = userProfile.allowTipsPackageRefund;
  }

  getTotalWinLose(): number {
    return this.win + this.lose;
  }

  getImgUrl(): string {
    return Util.getImgUrl(Constants.Enum_ImageType.indexOf("Profile"), this.id);
  }

  getRanking(): string {
    return this.rank == 99999999 ? "--" : String(this.rank);
  }

  getMaxProfitability() {
    return Math.min(Math.max(this.profitability / 3, 0), 100);
  }

}



// WEBPACK FOOTER //
// ./src/model/UserProfile.ts